<section class="flex-1 bg-white">
    <div class="max-w-[1400px] mx-auto px-6 py-16 flex flex-col items-center justify-center text-center">

        <div class="max-w-2xl w-full bg-app-background-20 rounded-2xl p-8 lg:p-16">
            <div class="flex flex-col items-center gap-6">
                <div class="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-sm">
                    <i class="fa-solid fa-envelope-circle-check text-4xl text-app-secondary-10"></i>
                </div>

                <div class="font-fraunce text-5xl font-normal text-app-primary-20">Bestätigung</div>

                <p class="text-xl text-gray-600 leading-relaxed">
                    {{ message }}
                </p>

                <div class="pt-8">
                    <button class="btn primary-button flex items-center justify-center gap-2 min-w-[200px]" [routerLink]="'/anmeldung'">
                        <span>Zum Login</span>
                        <i class="fa-solid fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>

    </div>
</section>
